import React from 'react';
import CouponForm from './form';
import {getUserDetail, updateUser} from '../../modules/Api';
import {notification} from 'antd';

class EditCoupon extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {},
            submitted: false
        }
        
    }
    componentDidMount() {
        this.fetchCouponDetail();
    }
    fetchCouponDetail() {
        const userId = this.props.match.params.id;
        getUserDetail(userId, data => {this.setState({data})});
    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const userId = this.props.match.params.id;
        const formData = values;
        updateUser(userId, formData, () => {
            notification.open({
                message: `کاربر با موفقیت ویرایش شد!`,
                description: ``
            })
            this.setState({submitted: false});
        })
    }
    render() {
        return (<div><CouponForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default EditCoupon;


// WEBPACK FOOTER //
// ./src/containers/Users/edit.js